import * as config from './config';

const envConfig = {
	ns: [
		'common',
		'candidate-feedback',
		'biz-collab-alt-feedback-spa',
		'biz-collab-form-builder-spa',
	],
	basePath: config.localeBasePath,
	cdn: config.localesCdn,
};

export const localeConfig = {
	defaultLanguage: 'en-US',
	...envConfig,
};

export default localeConfig;
